import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';
import { provideAuthContext } from './context/auth-context.providers';
import { provideExternalOktaAuth } from './external/external-okta-auth.providers';
import { provideInternalOktaAuth } from './internal/internal-okta-auth.providers';

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideInternalOktaAuth(),
    provideExternalOktaAuth(),
    provideAuthContext(),
  ]);
}
